import { __decorate, __param } from '../../../../../../external/tslib/tslib.es6.js';
import { IMarkerDecorationsService } from '../../common/services/markerDecorations.js';
import { registerEditorContribution, EditorContributionInstantiation } from '../editorExtensions.js';
let MarkerDecorationsContribution = class MarkerDecorationsContribution {
    static { this.ID = 'editor.contrib.markerDecorations'; }
    constructor(_editor, _markerDecorationsService) {
    }
    dispose() {
    }
};
MarkerDecorationsContribution = ( __decorate([
    ( __param(1, IMarkerDecorationsService))
], MarkerDecorationsContribution));
registerEditorContribution(MarkerDecorationsContribution.ID, MarkerDecorationsContribution, EditorContributionInstantiation.Eager);
export { MarkerDecorationsContribution };
